import { useState } from "react";
import { Table, Tbody, Td, Th, Thead, Tr,} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Pagination from "components/ui/pagination/Pagination";

export default function FilteredDataTable({ data }) {
  const { t } = useTranslation();

  /* --------------------------------------------- Start Pagination  -----------------------------------------------*/
  const recordsPerPage = 10;
  const [currentPageActive, setCurrentPageActive] = useState(1);
  const prePage = (currentPage, setCurrentPage) => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = (currentPage, setCurrentPage, npage) => {
    if (currentPage < npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const calculateRecords = (data, currentPage, recordsPerPage) => {
    const firstIndex = (currentPage - 1) * recordsPerPage;
    const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
    return data?.slice(firstIndex, lastIndex);
  };

  // Calculate records for activeDiscounts
  const businessDaysReportFilteredData = calculateRecords(
    data,
    currentPageActive,
    recordsPerPage
  );
  /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return  <>
      <>
        <Table>
          <Thead>
            <Tr>
              <Th>{t("pages.reports.reports_tables.business_date")}</Th>
              <Th>{t("pages.reports.reports_tables.opened_at")}</Th>
              <Th>{t("pages.reports.reports_tables.colosed_at")}</Th>
              <Th>{t("pages.reports.reports_tables.branch")}</Th>
              <Th>{t("pages.reports.reports_tables.branch_reference")}</Th>
              <Th>{t("pages.reports.reports_tables.opened_by")}</Th>
              <Th>{t("pages.reports.reports_tables.closed_by")}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {businessDaysReportFilteredData?.map((item, index) => (
              <Tr key={index}>
                  <Td>{item?.BusinessDate}</Td>
                  <Td>{item?.OpenedAt}</Td>
                  <Td> {item?.ClosedAt} </Td>
                  <Td> {item?.BranchName} </Td>
                  <Td> {item?.BranchReference} </Td>
                  <Td> {item?.OpenedBy} </Td>
                  <Td> {item?.ClosedBy} </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        <Pagination
          currentPage={currentPageActive}
          setCurrentPage={setCurrentPageActive}
          npage={Math.ceil(data?.length / recordsPerPage)}
          prePage={() => prePage(currentPageActive, setCurrentPageActive)}
          nextPage={() =>
            nextPage(
              currentPageActive,
              setCurrentPageActive,
              Math.ceil(data?.length / recordsPerPage)
            )
          }
        />
      </>
    </>
};
